import type { JobInvitationTranslations } from '../i18n/job-invitation';

export type JobInvitationStatus = 'pending' | 'accepted' | 'declined' | 'canceled';

export interface JobInvitationStatusOption {
  value: JobInvitationStatus;
  getLabel: (translations: JobInvitationTranslations) => string;
}

export const JOB_INVITATION_STATUSES: JobInvitationStatusOption[] = [
  {
    value: 'pending',
    getLabel: (translations) => translations.STATUS_PENDING
  },
  {
    value: 'accepted',
    getLabel: (translations) => translations.STATUS_ACCEPTED
  },
  {
    value: 'declined',
    getLabel: (translations) => translations.STATUS_DECLINED
  },
  {
    value: 'canceled',
    getLabel: (translations) => translations.STATUS_CANCELED
  }
];

/**
 * Gets all job invitation status options with translated labels
 * @param translations - The job invitation translations object
 * @returns Array of status options with translated labels
 */
export function getJobInvitationStatusOptions(translations: JobInvitationTranslations): Array<{value: JobInvitationStatus, label: string}> {
  return JOB_INVITATION_STATUSES.map(status => ({
    value: status.value,
    label: status.getLabel(translations)
  }));
}

/**
 * Gets the translated label for a specific status
 * @param status - The status value
 * @param translations - The job invitation translations object
 * @returns The translated status label
 */
export function getJobInvitationStatusLabel(status: JobInvitationStatus | string | null | undefined, translations: JobInvitationTranslations): string {
  switch (status) {
    case 'pending':
      return translations.STATUS_PENDING;
    case 'accepted':
      return translations.STATUS_ACCEPTED;
    case 'declined':
      return translations.STATUS_DECLINED;
    case 'canceled':
      return translations.STATUS_CANCELED;
    default:
      return status || '';
  }
}

/**
 * Gets all possible job invitation status values
 * @returns Array of all possible JobInvitationStatus values
 */
export function getJobInvitationStatusValues(): JobInvitationStatus[] {
  return JOB_INVITATION_STATUSES.map(status => status.value);
}
